import React, { Component } from 'react';
import ThreeOptions from './ThreeOptions';
import FourOptions from './FourOptions';

class Step4 extends Component {
    render() {
        return (
            <div className="card card-body">
                <div className="form-group">
                    <div className="h2">C2. TRANSMITTING UNIT TEST</div>
                    <div className="h5"><b>YES</b> - Tested Correctly || <b>NO</b> - Did Not Test Correctly || <b>NA</b> - Feature Not Available</div>
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="testPowerOn"
                        label="Power On Visual Indicator"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="testCommonTrouble"
                        label="Common Visual Trouble Signal"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="testCommonAudible"
                        label="Common Audible Trouble Signal"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="testPowerFailure"
                        label="Main Power Supply Failure Signal"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="testAlarmSignalOperation"
                        label="Alarm Signal Operation"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="testInputCircuit"
                        label="Input Circuit Trouble Operation"
                    />
                </div>
                <div className="form-group">
                    <ThreeOptions
                        name="testPowerSupply"
                        label="Main Power Supply to Emergency Power Supply Transfer"
                    />
                </div>
                {/* TODO: Move to Communication Test section */}
                {/* <div className="form-group">
                    <FourOptions
                        name="testCommunication180"
                        label="Trouble Signal Indicating Failure of Primary Path of Communications Received Within 180 Secs"
                    />
                </div>
                <div className="form-group">
                    <FourOptions
                        name="testCommunicationRestoral"
                        label="Trouble Signal Indicating Failure of Primary Path of Communications Received"
                    />
                </div>
                <div className="form-group">
                    <FourOptions
                        name="testCommunicationBackup180"
                        label="Trouble Signal Indicating Failure of Secondary Backup Path of Communications Received Within 180 Secs"
                    />
                </div>
                <div className="form-group">
                    <FourOptions
                        name="testCommunicationBackupRestoral"
                        label="Trouble Signal Indicating Failure of Secondary Backup Path of Communications Received"
                    />
                </div> */}
            </div>
        );
    }
}

export default Step4;



// WEBPACK FOOTER //
// ./src/components/Step4.js